import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = { currency_symbol: "\u20b9", club_open: false, gst_enabled: true, gst_rate: 5 };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      return data;
    } catch {
      return DEFAULTS;
    }
  }, []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 60000);
    return () => clearInterval(t);
  }, [reload]);

  return (
    <SettingsContext.Provider value={{ settings, reload, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULTS, reload: () => {} };
